import { api } from "../../api/api";
import {
  SEASONAL_REQUEST, GET_SEASONAL_SUCCESS, ADD_SEASONAL_SUCCESS,
  UPDATE_SEASONAL_SUCCESS, DELETE_SEASONAL_SUCCESS, SEND_SEASONAL_SUCCESS,
  GET_SEASONAL_ORDERS_SUCCESS, UPSERT_SEASONAL_ORDER_SUCCESS,
  UPDATE_ORDER_STATUS_SUCCESS, SEASONAL_FLAG_OFF,
} from "../constant";

export const getSeasonalMenus = (userId) => async (dispatch) => {
  if (userId == null || userId === '') return;
  dispatch({ type: SEASONAL_REQUEST });
  try {
    const { data } = await api.get(`/seasonal/getall/${userId}`);
    dispatch({ type: GET_SEASONAL_SUCCESS, payload: data.menus });
  } catch (e) { console.error(e); }
};

export const addSeasonalMenu = (obj) => async (dispatch) => {
  try {
    const { data } = await api.post("/seasonal/add", obj);
    dispatch({ type: ADD_SEASONAL_SUCCESS, payload: data.menu });
  } catch (e) { console.error(e); }
};

export const updateSeasonalMenu = (id, obj) => async (dispatch) => {
  try {
    const { data } = await api.patch(`/seasonal/update/${id}`, obj);
    dispatch({ type: UPDATE_SEASONAL_SUCCESS, payload: data.menu });
  } catch (e) { console.error(e); }
};

export const deleteSeasonalMenu = (id) => async (dispatch) => {
  try {
    await api.delete(`/seasonal/delete/${id}`);
    dispatch({ type: DELETE_SEASONAL_SUCCESS, payload: id });
  } catch (e) { console.error(e); }
};

export const sendSeasonalMenu = (menuId, userId, channel = 'email') => async (dispatch) => {
  try {
    const { data } = await api.post("/seasonal/send", { menuId, userId, channel });
    dispatch({ type: SEND_SEASONAL_SUCCESS, payload: data.menu });
    return data;
  } catch (e) { console.error(e); }
};

export const getSeasonalOrders = (menuId) => async (dispatch) => {
  try {
    const { data } = await api.get(`/seasonal/orders/${menuId}`);
    dispatch({ type: GET_SEASONAL_ORDERS_SUCCESS, payload: { menuId, orders: data.orders } });
  } catch (e) { console.error(e); }
};

export const upsertSeasonalOrder = (obj) => async (dispatch) => {
  try {
    const { data } = await api.post("/seasonal/order", obj);
    dispatch({ type: UPSERT_SEASONAL_ORDER_SUCCESS, payload: data.order });
  } catch (e) { console.error(e); }
};

export const updateOrderStatus = (orderId, status, notifyEmail) => async (dispatch) => {
  try {
    const { data } = await api.patch(`/seasonal/order/status/${orderId}`, { status, notifyEmail });
    dispatch({ type: UPDATE_ORDER_STATUS_SUCCESS, payload: data.order });
  } catch (e) { console.error(e); }
};

export const seasonalFlagOff = () => ({ type: SEASONAL_FLAG_OFF });
